/* CVF-045-AB winner — permanent */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.cvf-045-ab-decision-guide');
  if (!root) return;

  const sectionEl = root.closest('.shopify-section') || root;
  const productGrid = document.getElementById('ProductGridContainer');
  if (!productGrid || !productGrid.parentNode) return;
  if (sectionEl.nextElementSibling === productGrid) return;

  productGrid.parentNode.insertBefore(sectionEl, productGrid);
});
